import { FormHelperText, Grid, Typography } from "@mui/material";
import { Control, Controller } from "react-hook-form";
import { IntegrationOnOffSwitch } from "./IntegrationOnOffSwitch";

interface IntegrationToggleOptionProps {
  title: string;
  description: string;
  toggleSize?: "small" | "medium";
  helperText?: {
    message: string;
    icon?: React.ReactNode;
    color?: string;
  };
  formOptions: {
    name: string;
    control: Control<any>;
  };
  disabled?: boolean;
}

export function IntegrationToggleOption({
  title,
  description,
  toggleSize = "small",
  formOptions: { control, name },
  helperText,
  disabled,
}: IntegrationToggleOptionProps) {
  return (
    <Grid
      container
      sx={{
        "& .form-text": {
          color: disabled ? "text.disabled" : undefined,
        },
      }}
    >
      <Grid size="grow">
        <Typography fontWeight={700} className="form-text">
          {title}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          className="form-text"
        >
          {description}
        </Typography>
      </Grid>
      <Grid sx={{ pr: 2 }} size="auto">
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <IntegrationOnOffSwitch {...{ field, toggleSize, disabled }} />
          )}
        />
      </Grid>
      {helperText && (
        <Grid size={12}>
          <FormHelperText
            margin="dense"
            sx={{
              display: "flex",
              alignItems: "center",
              color: helperText?.color,
            }}
            className={disabled ? "form-text" : ""}
          >
            {helperText?.icon}
            {helperText.message}
          </FormHelperText>
        </Grid>
      )}
    </Grid>
  );
}
